import { useField } from "formik";

import { FormControl } from "shared/ui/components/FormControl";

const FormikField = ({
  withControl = true,
  name,
  hidden = false,
  withoutError = false,
  component: Component,
  controlProps,
  componentProps,
}: any) => {
  const [field, meta, helpers] = useField(
    componentProps?.type === "checkbox" || componentProps?.type === "radio"
      ? {
          name,
          type: componentProps.type,
          value: componentProps.value,
        }
      : name
  );

  const { touched, error } = meta;

  const haveError = touched && !!error && !withoutError;

  if (hidden) {
    return null;
  }

  if (!withControl) {
    return (
      <Component
        haveError={haveError}
        name={name}
        error={withoutError ? undefined : error}
        field={field}
        helpers={helpers}
        {...componentProps}
      />
    );
  }

  return (
    <FormControl haveError={haveError} error={!withoutError ? error : undefined} {...controlProps}>
      <Component
        haveError={haveError}
        name={name}
        field={field}
        helpers={helpers}
        {...componentProps}
      />
    </FormControl>
  );
};

export default FormikField;
